import React, { useLayoutEffect, useState } from 'react';
import { Header } from 'layouts/Header';
import Content from 'layouts/Content';
import 'assets/styles/global.less';
import 'assets/js/iconfont';
import './index.less';
import Footer from 'layouts/Footer';
import { sso } from '@i18n/uc';
import Loading from 'components/Loading';
import { logFMP, logCustom } from 'logger/logger';
import { ENTRY_SYSTEM } from 'logger/eventType';
import { useGetWebAccountInfoUsingPOST } from 'query/webAccount';

const App: React.FC = () => {
    const [flag, setFlag] = useState(false);
    const userInfo = useGetWebAccountInfoUsingPOST({ enabled: flag });

    const refreshLoginStatus = async () => {
        await sso.refreshLoginStatus();
        setFlag(true);
    };

    useLayoutEffect(() => {
        if (userInfo.isSuccess) {
            console.log('isSuccess');
            logCustom(ENTRY_SYSTEM, {
                info: userInfo.data,
            });
            logFMP();
        }
    }, [userInfo.data, userInfo.isSuccess]);

    useLayoutEffect(() => {
        console.log('覆盖率');
        refreshLoginStatus();
        return () => {
            setFlag(false);
        };
    }, []);

    if (!flag) {
        return <Loading />;
    }

    return (
        <div className="app">
            <Header />
            <Content />
            <Footer />
        </div>
    );
};

export default App;
